import React, { useState, useEffect } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import { RxCrossCircled, RxCheckCircled } from "react-icons/rx";
import { useTranslation } from 'react-i18next';

function ComandosHistoricos(props) {
    const { code } = props;
    const { t } = useTranslation();


    // ============================================================= DATOS =================================================================================
    const [logs, setLogs] = useState([]);
    let number = 0;
    useEffect(() => {
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/logs/commandsHistory", { method: 'GET', credentials: 'include' })
            .then(async (dataINV) => { setLogs(await dataINV.json()); console.log('Recibo datos'); })
            .catch(e => { console.log(e); })
        var interval1 = setInterval(function () {
            number++;
            if (code == sessionStorage.getItem("key")) { // No ha cambiado de página
                fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/logs/commandsHistory", { method: 'GET', credentials: 'include' })
                    .then(async (dataINV) => { setLogs(await dataINV.json()); console.log('Refersco datos'); })
                    .catch(e => { console.log(e); })
            } else { // Ha cambiado de página. Cancela bucle
                console.warn('Cancelo hilo')
                clearInterval(interval1);
            }
        }, 30000)
    }, [number]);

    // ==================================================== TAMAÑO TABLA DE DATOS ===========================================================================

    /*Tamaño para las columnas de la tabla y cuatas filas de alarmas queremos*/
    var anchoPantalla, columnasTabla, ocupadoPorcentaje, pixelesOcupados, pixelesRestantes, tamañoColum, tamañoColumMedio, tamColumPeque, tamañoDescri, tamañoFechas;
    var filas_alarmas;

    if (window.self.innerHeight > 720 && window.self.innerWidth > 1023) {
        /*Tamaño para las columnas de la tabla, respecto al sitio ocupado en pantalla */
        anchoPantalla = window.screen.width;
        columnasTabla = 9;
        ocupadoPorcentaje = 30;
        pixelesOcupados = (anchoPantalla * ocupadoPorcentaje) / 100;
        pixelesRestantes = anchoPantalla - pixelesOcupados;
        tamañoColum = (pixelesRestantes / columnasTabla) - 0.18;
        tamañoColumMedio = tamañoColum * 0.75;
        tamColumPeque = tamañoColum / 2;

        tamañoDescri = tamañoColum + tamañoColumMedio;
        tamañoFechas = tamañoColum + (tamañoColumMedio / 4);
        filas_alarmas = 12;
    } else {
        /*Tamaño para las columnas de la tabla, si es en movil o tablet*/
        tamañoColum = 110;
        tamañoColumMedio = 95;
        tamColumPeque = 90;
        tamañoDescri = 380;
        tamañoFechas = 160;
        filas_alarmas = 10;
    }

    let columnas = [{ field: 'id', headerName: t('scada.solarFarm.commands.historical.id'), width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center', hide: true, cellClassName: 'cell-solarfarm-id' },
    { field: 'timeStampSent', headerName: t('scada.solarFarm.commands.historical.sendData'), width: tamañoFechas, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-solarfarm' },
    { field: 'timeStampExecuted', headerName: t('scada.solarFarm.commands.historical.runData'), width: tamañoFechas, headerClassName: 'super-app-theme--header', cellClassName: 'cell-solarfarm', headerAlign: 'center' },
    { field: 'deviceType', headerName: t('scada.solarFarm.commands.historical.deviceType'), width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-solarfarm' },
    { field: 'deviceName', headerName: t('scada.solarFarm.commands.historical.name'), width: tamColumPeque, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-solarfarm' },
    { field: 'command', headerName: t('scada.solarFarm.commands.historical.command'), width: tamañoColum, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-solarfarm' },
    { field: 'parameter', headerName: t('scada.solarFarm.commands.historical.parameter'), width: tamañoColumMedio, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-solarfarm' },
    { field: 'user', headerName: t('scada.solarFarm.commands.historical.user'), width: tamañoColumMedio, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-solarfarm' },
    { field: 'wasSuccessful', headerName: t('scada.solarFarm.commands.historical.result'), width: tamañoColumMedio, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-solarfarm', type: 'boolean' },
    { field: 'comment', headerName: t('scada.solarFarm.commands.historical.description'), width: tamañoDescri, headerClassName: 'super-app-theme--header', headerAlign: 'center', cellClassName: 'cell-solarfarm' }];

    // ===================================================== PROCESADO DE DATOS =============================================================================

    var [filas, setFilas] = useState([]);

    useEffect(() => {
        var array = [];
        logs.map((dato, index) => {
            const { id, timeStampSent, timeStampExecuted, deviceType, deviceName, command, parameter, user, wasSuccessful, comment } = dato;
            let successfulIcon = <></>;
            if (wasSuccessful) {
                successfulIcon = <RxCheckCircled color={'green'} />
            } else {
                successfulIcon = <RxCrossCircled color={'red'} />
            }

            array.push({ id: id, timeStampSent: timeStampSent, timeStampExecuted: timeStampExecuted, deviceType: deviceType, deviceName: deviceName, command: command, parameter: parameter, user: user, wasSuccessful: wasSuccessful, comment: comment });
        });

        // Se le da la vuelta para que muestre los más actuales primero
        setFilas(array);
    }, [logs]);

    // ============================================================== RETURN =================================================================================

    return (
        <div className='container-fluid' style={{ marginTop: '15px' }}>
            <div className='row'>
                <div className='col'>
                    <div className='row'>
                        <div className='col-auto'>
                            <h5>{t('scada.solarFarm.commands.historical.header')}</h5>
                        </div>
                        <div className='row' style={{ margin: "0%", padding: "0%" }}>
                            <div className='col-auto' id='div-table-commands-history'>
                                <DataGridPro
                                    sx={{
                                        width: '100%',
                                        '& .super-app-theme--header': { backgroundColor: 'rgb(10,80,190)', color: 'white' },
                                        '& .super-app-theme--Activa': { color: 'red' },
                                        '& .super-app-theme--Inactiva': { color: 'green' },
                                    }}
                                    rows={filas} columns={columnas} pagination pageSize={filas_alarmas} autoHeight={true}
                                    componentsProps={{ toolbar: { csvOptions: { delimiter: ';', utf8WithBom: true, fileName: "HistoricoComandos" } } }}
                                    components={{ Toolbar: GridToolbarExport }} disableSelectionOnClick
                                    getRowClassName={(params) => `super-app-theme--${params.row.estado}`}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ComandosHistoricos;